import script from "./LicenseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicenseModal.vue?vue&type=script&setup=true&lang=ts"

import "./LicenseModal.vue?vue&type=style&index=0&id=74394ea6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74394ea6"]])

export default __exports__